import React, { PropsWithChildren } from "react";
import Typography, {
  ITypographyProps,
} from "../../Foundation/Typography/Typography";
import { _AlertBlockRoot } from "./AlertBlock.styled";

export enum EAlertBlockVariant {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}
export interface IAlertBlockProps {
  variant?: EAlertBlockVariant;
  text?: string | React.ReactNode;
  size?: "small" | "medium";
  style?: ITypographyProps["style"];
}
const AlertBlock = (props: IAlertBlockProps) => {
  const {
    text = "",
    style,
    size = "medium",
    variant = EAlertBlockVariant.ERROR,
  } = props;
  return (
    <_AlertBlockRoot {...{ variant, style }}>
      <Typography
        variant={size === "small" ? "ui4" : "body2"}
        color={"greyText"}
      >
        {text}
      </Typography>
    </_AlertBlockRoot>
  );
};
export default AlertBlock;
